import React from 'react';
import { PropagateLoader } from 'react-spinners';
import { Col, Row } from 'react-bootstrap';

export default function LoadingIcon(props) {
  const { loadingText } = props;
  return (
    <>
      <Row />
      <Row>
        <Col md="2" />
        <Col md="8" align="center">
          <br />
          <h2>{loadingText}</h2>
        </Col>
        <Col md="2" />
      </Row>
      <Row>
        <Col md="2" />
        <Col md="8" align="center">
          <br />
          <PropagateLoader color="navy" loading="true" size={15} />
        </Col>
        <Col md="2" />
      </Row>
    </>
  );
}
